import { useEffect, useContext } from 'react';
import { ClientConfigurationContext } from '../context/ClientConfigurationContextProvider';


export default function useGtmTracking(viewName, eventName) {
    const clientConfiguration = useContext(ClientConfigurationContext);
    const isTagManagerEnabled = clientConfiguration?.enableTagManager && clientConfiguration?.tagManagerUrl != null && clientConfiguration?.tagManagerUrl.trim() !== "";

    useEffect(() => {

        if (!isTagManagerEnabled) {
            return;
        }
        const trackEvent = () => {
            if (typeof window !== 'undefined' && window._gtm) {
                try {
                    window._gtm.track(eventName, {
                        viewName: `AgencyIdentity:${viewName}`,
                        eventName: eventName
                    });
                } catch (error) {
                    console.error('Error tracking GTM event:', error);
                }
            } else {
                console.warn('GTM tracking not available - window._gtm is undefined');
            }
        };

        // Try immediately
        trackEvent();

        // If _gtm is not available, set up a retry mechanism
        if (!window._gtm) {
            const checkGtmInterval = setInterval(() => {
                if (window._gtm) {
                    trackEvent();
                    clearInterval(checkGtmInterval);
                }
            }, 100); // Check every 100ms

            // Clear interval after 1 seconds to avoid infinite checking
            setTimeout(() => {
                clearInterval(checkGtmInterval);
            }, 1000);
        }
    }, []);
};
